<script>
// import productsCSV from '../products.csv'
import Papa from 'papaparse'
import VueJsonToCsv from 'vue-json-to-csv'
import { toRaw } from 'vue'
import { ref } from 'vue'

import Item from './Item.vue'
import { read, utils } from 'xlsx'

export default {
  props: {
    value: String,
  },
  components: {
    Item,
  },
  setup() {
  },
  data() {
    return {
      excelData: [],
      headers: [],
      tempText: '',
      searchText: '',
      voting: false,
      cart: [],
      copyText: '',
      hideCart: true,
      copied: false,
      productsCSV:[]
    }
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (!file) return

      const reader = new FileReader()
      reader.onload = (e) => {
        const arrayBuffer = e.target.result
        const workbook = read(arrayBuffer, { type: 'array' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]

        // Convert sheet to an array of objects (useful for sending to components)
        const jsonOptions = { header: 1 } // Use header 1 to get array of arrays
        const data = utils.sheet_to_json(worksheet, jsonOptions)
        if (data.length > 0) {
          // Assuming the first row is headers
          this.headers.value = data[0]
          // The rest of the data is the rows
          this.excelData = data.slice(8, data.length - 1)
        }
      }
      reader.readAsArrayBuffer(file)
    },
    searchItems() {
      this.searchText = this.tempText
      this.tempText = ''
    },
    checkbox(){
      this.voting = !this.voting
    },
    copyCart() {
      // Get the text field
      for(var i = 0; i < this.cart.length; i ++){
        this.copyText = this.copyText + this.cart[i].toString() + '\n'
      }

      // Copy the text inside the text field
      navigator.clipboard.writeText(this.copyText);
      this.copied = true

      setTimeout(() => {
        this.copied = false
      }, 3000)
    },
    clearCart(){
      this.cart.length = 0
    },
    handleFileUploadProd(event){
      const file = event.target.files[0]
      if (file) {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            this.productsCSV = results.data;
            console.log("Parsing complete:", this.productsCSV);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          }
        })
      }
    },
  },
}
</script>

<template>
  <div class="container">
    <p v-if="!productsCSV.length">Product</p>
    <input v-if="!productsCSV.length" id="choose-file" type="file" @change="handleFileUploadProd" accept=".csv" placeholder="Enter Product CSV" /> <br>
    <p v-if="!excelData.length">Report</p>
    <input v-if="!excelData.length" id="choose-file" type="file" @change="handleFileUpload" accept=".xls,.xlsx" />
    <div v-if="excelData.length">
       <div class="search-b">
        <input id="s-btn" v-model="tempText" @keyup.enter="searchItems" placeholder="Search" />
        <br>
        <input type="checkbox" id="myCheck" @click="checkbox">Include Voting Blazers</input>
        <br />
       </div>

      <div class="cart">
        <div v-if="this.hideCart" class="show-cart">
          Cart: {{ this.cart }}
        </div>

        <br>
        <p v-if="this.copied">Copied</p>
        <button @click="copyCart">Copy Cart</button>
        <button @click="this.hideCart = !this.hideCart">Hide Text</button>
        <button id="clear" @click="clearCart">Clear Cart</button>

      </div>

      <div class="items-container" v-for="(row, rowIndex) in this.excelData" :key="rowIndex">
        <!-- Item Barcode -->
        <div v-if="row[4].toLowerCase().includes(this.searchText.toLowerCase()) &&  !row[3].includes('BLM') && !row[3].includes('OLD')">
          <div v-if="this.voting">
            <Item :sku="row[2]" :barcode="row[1]" :name="row[4]" :available="row[10]" :cart="this.cart" :productsCSV="this.productsCSV" />
          </div>
          <div v-else-if="!this.voting && !row[4].includes('Voting') && !row[3].includes('BLM') && !row[3].includes('OLD')">
            <Item :sku="row[2]" :barcode="row[1]" :name="row[4]" :available="row[10]" :cart="this.cart" :productsCSV="this.productsCSV"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
button {
  background-color: blueviolet;
  color: white;
  padding-top: .5em;
  padding-bottom: .5em;
  border-radius: 1em;
  border: 2px solid white;
  margin: 1em;

  #clear{
    color: red;
  }
}
button:hover {
  background-color: #892be29a;
  cursor: pointer;
}
#choose-file{
  padding: 0.5em;
  border: 4px solid black;
  margin-bottom: 1em;


}
.items-container {
  display: inline-grid;
  grid-template-columns: auto auto auto auto;
}
.cart{
  padding: 1em;
  position: fixed;
  top: 0;
  right: 0;
  width: 15vw;
  background-color: rgba(100, 36, 160, 0.432);
  border-radius: 20px;
  max-height: 25vh;
  overflow-y:scroll;
  overflow-x:hidden;
  p{
    color: rgb(103, 255, 103);
    font-weight: bold;
  }

}
.search-b{
  margin-left: auto;
  margin-right:auto;
  text-align: center;
}
#s-btn{
  padding:.5em;
}

</style>
